import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import type { ProductSubpageConfig } from '../../../product-subpage/types';

export const PlatformSubPageHeroImage: React.FC<{
  src: string;
  alt: string;
  width: number;
  height: number;
}> = ({ src, alt, width, height }) => (
  <img
    src={src}
    alt={alt}
    className="platform-sub-hero-img"
    width={width}
    height={height}
    loading="eager"
    decoding="async"
  />
);

export const PlatformPremiumHero: React.FC<{
  config: ProductSubpageConfig;
  heroVisual?: React.ReactNode;
}> = ({ config, heroVisual }) => (
  <section
    className="platform-sub-hero platform-sub-hero--premium"
    aria-labelledby={`platform-sub-${config.slug}-title`}
  >
    <div className="platform-sub-hero__glow" aria-hidden />
    <div className="platform-sub-hero__inner">
      <div className="platform-sub-hero__content">
        <h1 id={`platform-sub-${config.slug}-title`} className="platform-sub-hero__title">
          {config.hero.title}
        </h1>
        <p className="platform-sub-hero__subtitle">{config.hero.subtitle}</p>
        <div className="platform-sub-hero__actions">
          <Link to={config.hero.primaryCta.to} className="platform-sub-hero__cta platform-sub-hero__cta--primary">
            {config.hero.primaryCta.label}
            <ArrowRight size={18} strokeWidth={2.25} aria-hidden />
          </Link>
        </div>
      </div>
      <div className="platform-sub-hero__visual">
        {heroVisual ?? (
          <div className="platform-sub-hero-visual">
            <PlatformSubPageHeroImage
              src={config.heroImage.src}
              alt={config.heroImage.alt}
              width={config.heroImage.width}
              height={config.heroImage.height}
            />
          </div>
        )}
      </div>
    </div>
  </section>
);
